var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemp2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 324,
    viewBox: "0 0 725 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1135_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712 1.00003L13 1.00003C6.37261 1.00003 1.00003 6.37261 1.00003 13L0.999999 93C0.999996 99.6274 6.37259 105 13 105L51.9337 105C58.5611 105 63.9337 110.373 63.9336 117L63.9336 311.5C63.9336 318.127 69.3062 323.5 75.9336 323.5L665.071 323.5C668.255 323.5 671.309 322.234 673.559 319.982L720.489 273.014C722.737 270.764 724 267.713 724 264.532L724 13C724 6.37261 718.627 1.00003 712 1.00003Z",
    fill: "#282828",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712 1.00003L13 1.00003C6.37261 1.00003 1.00003 6.37261 1.00003 13L0.999999 93C0.999996 99.6274 6.37259 105 13 105L51.9337 105C58.5611 105 63.9337 110.373 63.9336 117L63.9336 311.5C63.9336 318.127 69.3062 323.5 75.9336 323.5L665.071 323.5C668.255 323.5 671.309 322.234 673.559 319.982L720.489 273.014C722.737 270.764 724 267.713 724 264.532L724 13C724 6.37261 718.627 1.00003 712 1.00003Z",
    stroke: "white",
    strokeOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1135_470",
    x: -79.5,
    y: -79.5,
    width: 884,
    height: 483.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1135_470"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1135_470",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp2);
export default __webpack_public_path__ + "static/media/temp2.cfcefbc1b52b84b2b3175c0536837053.svg";
export { ForwardRef as ReactComponent };